import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import {
  ApolloClient,
  ApolloProvider,
  InMemoryCache,
  createHttpLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { AuthProvider } from "./auth/AuthProvider";

const httpLink = createHttpLink({
  // uri: "http://localhost:3000/graphql",
  // uri: "https://utopia-snitch-celery.ngrok-free.dev/graphql",
  // Set REACT_APP_GRAPHQL_URI (e.g. in .env.local) to point at a local backend.
  uri: "https://api.barbera.in/graphql",
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("token"); // 👈 From session storage
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const client = new ApolloClient({
  uri: "https://api.barbera.in/graphql",
  // uri: "http://localhost:3000/graphql",
  // uri: "https://utopia-snitch-celery.ngrok-free.dev/graphql",
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

// Browsers change a focused number field when you scroll over it, silently
// editing amounts. Dropping focus lets the page scroll and leaves the value alone.
document.addEventListener(
  "wheel",
  (e) => {
    if (e.target === document.activeElement && e.target.type === "number") {
      e.target.blur();
    }
  },
  { passive: true },
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ApolloProvider client={client}>
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </ApolloProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
